/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ForgetEntityRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ForgetEntityResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const forgetEntity = (request: ForgetEntityRequest, options?: CashRequestOptions) => post<ForgetEntityRequest, ForgetEntityResponse>("/2.0/cash/forget-entity", request, {...options, rejectOnError: true })